import { createSlice } from "@reduxjs/toolkit";
import { fetchAllProperties } from "./thunk";

export interface AllProperty {
  _id: string;
  state: string;
  city: string;
  area: { _id: string; areaName: string };
  street:{ _id: string; street: string };
  surveyNumbers: string[];
  guidelineRate: number;
  marketRate: { min: number; max: number };
}

export interface FilterState {
  page: number;
  limit: number;
  search: string;
  state: string;
  city: string;
  area: string;
  sortBy: string;
  sortOrder: string;
  totalCount: number;
}

const initialState = {
  allPropertiesList: [],
  filterData: {
    page: 1,
    limit: 10,
    search: "",
    state: "",
    city: "",
    area: "",
    sortBy: "",
    sortOrder: "",
    totalCount: 0,
  } as FilterState,
};

const allPropertiesSlice = createSlice({
  name: "allProperties",
  initialState,
  reducers: {
    setFilterData(state, action) {
      state.filterData = { ...state.filterData, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllProperties.fulfilled, (state, action:any) => {
      state.allPropertiesList = action.payload.data || [];
      state.filterData.totalCount = action.payload.total;
    });
  },
});

export const { setFilterData } = allPropertiesSlice.actions;
export default allPropertiesSlice.reducer;
